/**
 * Τα δύο σχήματα του σήματος Xentrix (καμπύλες Bezier από το αρχείο του λογότυπου), σε συντεταγμένες
 * του αρχικού σχεδίου. Από τη νέα εμφάνιση (14/10/2026) το σήμα ζωγραφίζεται επίπεδο (LoginLogoSculpture):
 * το τρισδιάστατο πλέγμα WebGL που χτιζόταν από αυτά τα περιγράμματα έφυγε μαζί με το γλυπτό.
 */
export const LOGO_PATHS = [
  'M724 471 C731 343 634 268 513 274 C374 275 263 393 263 539 C261 600 283 647 338 647 C380 647 410 606 439 560 C489 472 538 420 606 418 C651 417 699 439 724 471 Z',
  'M358 698 C412 689 456 659 490 606 C535 538 564 471 638 473 C715 468 732 512 713 574 C693 666 592 744 492 744 C437 746 391 730 358 698 Z',
] as const;

/** Το τετράγωνο που κλείνει και τα δύο σχήματα (ίδιο με το παλιό εφεδρικό SVG του γλυπτού). */
export const LOGO_VIEWBOX = '235 247 525 525';
